import * as LucideIcons from "lucide-react";
import { Circle } from "lucide-react";

// Convert kebab-case icon_keyword (e.g. "alert-circle") to Lucide PascalCase ("AlertCircle")
function toPascal(keyword) {
  if (!keyword) return "";
  return keyword
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join("");
}

export function getLucideIcon(keyword) {
  const pascal = toPascal(keyword);
  return LucideIcons[pascal] || LucideIcons["Sparkles"] || Circle;
}
